// Centralised route constants for the rent-receipts sub-module.
// A backend route rename is a one-file change.

const RENT_RECEIPTS = '/api/admin/rental-distributions/rent-receipts'

export const RENT_RECEIPTS_ENDPOINT_PATHS = {
  LIST: RENT_RECEIPTS,
  STATUS_COUNTS: `${RENT_RECEIPTS}/status-counts`,
  CREATE: RENT_RECEIPTS,
  PREVIEW: `${RENT_RECEIPTS}/preview`,

  DETAIL: (receiptId: string) => `${RENT_RECEIPTS}/${receiptId}`,
  UPDATE: (receiptId: string) => `${RENT_RECEIPTS}/${receiptId}`,
  RECONCILE: (receiptId: string) => `${RENT_RECEIPTS}/${receiptId}/reconcile`,
  ACCEPT_VARIANCE: (receiptId: string) => `${RENT_RECEIPTS}/${receiptId}/accept-variance`,
  DISPUTE: (receiptId: string) => `${RENT_RECEIPTS}/${receiptId}/dispute`,
  ACKNOWLEDGE_THRESHOLDS: (receiptId: string) =>
    `${RENT_RECEIPTS}/${receiptId}/acknowledge-thresholds`,
  SUBMIT_FOR_APPROVAL: (receiptId: string) => `${RENT_RECEIPTS}/${receiptId}/submit-for-approval`,
  APPROVAL_PERMISSION: (receiptId: string) => `${RENT_RECEIPTS}/${receiptId}/approval-permission`,
  APPROVE: (receiptId: string) => `${RENT_RECEIPTS}/${receiptId}/approve`,
  REJECT: (receiptId: string) => `${RENT_RECEIPTS}/${receiptId}/reject`,
  CORRECT: (receiptId: string) => `${RENT_RECEIPTS}/${receiptId}/correct`,
} as const
